// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__0Qq5-","card-img":"CardTile_card-img__OYD-r"};